export default __webpack_public_path__ + "static/media/signup-enewsletter.83521bae.png";